import { Box } from "@mui/material";
import ThemeContext from "components/app/Context";
import { useContext } from "react";
import { useAppSelector } from "redux/hooks";
import colors from "styles/Colors";
import { accessTypes } from "utils/CommonConstants";
import Button from "../../../common/Button";

interface Props {
  label?: string;
  showMenu?: boolean;
  buttonSize?: any;
  sx?: any;
  getOnClickForCreatePlan: any;
}

function CreatePlanButton(props: Readonly<Props>) {
  const { getOnClickForCreatePlan, sx, label = "Create Custom Plan" } = props;
  const isCorp = useAppSelector((state) => state.app.loggedInUserDetails.isCorp);
  const isConsultant = useAppSelector((state) => state.app.loggedInUserDetails.isConsultant);
  const { isMobileScreen } = useContext(ThemeContext);

  const PlanButton = (
    <Button
      size={props.buttonSize}
      accessType={accessTypes.update}
      sx={{ ...sx, width: isMobileScreen ? "90%" : "auto" }}
      label={label}
      onClick={getOnClickForCreatePlan}
    />
  );

  return (
    <>
      {!isCorp &&
        !isConsultant &&
        (!isMobileScreen || props.buttonSize ? (
          PlanButton
        ) : (
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-evenly",
              padding: "24px 0px 24px 0px",
              marginX: "-16px",
              background: colors.Neutral.Neutral0,
              zIndex: 99
            }}
          >
            {PlanButton}
          </Box>
        ))}
    </>
  );
}

export default CreatePlanButton;
